import { ObjectSchema, number, object, string, array } from 'yup';
import { locale } from '../yup-locale';
import * as yup from 'yup';
import {
    AlarmGroup,
    alarmGroupNameMaxLimit,
    descriptionMaxLimit,
    OutputAddress,
    OutputSettingMode,
    OutputSettingType,
    SettingsAddress,
    SignalWidthMax,
    SignalWidthMin,
} from '../../models/alarm-group';
import './../custom-method';

yup.setLocale(locale);

export function alarmGroupValidator(): ObjectSchema<AlarmGroup> {
    return object({
        id: string().uuid().strict(),
        groupNo: number().required().nonNullable().strict(),
        vesselId: string().uuid().strict(),
        name: string().required().nonNullable().strict().max(alarmGroupNameMaxLimit),
        description: string().nullable().strict().max(descriptionMaxLimit),
        categories: array().of(string()).required().nonNullable().strict(),
    })
        .strict()
        .noUnknown() as ObjectSchema<AlarmGroup>;
}

export function settingsAddressValidator(): ObjectSchema<SettingsAddress> {
    return object({
        fcuNum: number().required().nonNullable().strict(),
        fuNum: number().required().nonNullable().strict(),
        slotNum: number().required().nonNullable().strict(),
        terminal: number().required().nonNullable().strict(),
        settingId: string().notRequired().nullable(),
    });
}

export function outputAddressValidator(): ObjectSchema<OutputAddress> {
    return object({
        index: number().required().nonNullable().strict(),
        type: string().oneOf(Object.values(OutputSettingType)).nonNullable().required(),
        mode: string().oneOf(Object.values(OutputSettingMode)).nonNullable().required(),
        address: settingsAddressValidator(),
        signal: number().notRequired().nullable().strict().numberBetween(SignalWidthMin, SignalWidthMax),
    })
        .strict()
        .noUnknown() as ObjectSchema<OutputAddress>;
}
